module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loading', {
    attrs: {
      "ativo": _vm.loading.visivel,
      "mensagem": _vm.loading.mensagem
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "tabela tabela_listrada tabela_com-largura-total"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Valor")]), _vm._v(" "), _c('th', [_vm._v("Cidade")]), _vm._v(" "), _c('th', [_vm._v("Emenda")]), _vm._v(" "), _c('th', {
    staticClass: "u-texto-alinhado-ao-centro"
  }, [_vm._v("Publicação da emenda")]), _vm._v(" "), _vm._l((_vm.colunasDinamicas), function(faixa) {
    return _c('th', {
      key: faixa,
      staticClass: "u-texto-alinhado-ao-centro"
    }, [_vm._v("\n                    " + _vm._s(faixa) + "\n                ")])
  }), _vm._v(" "), _c('th')], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.aportesLocais), function(aporte) {
    return _c('tr', {
      key: aporte.Id
    }, [_c('td', [_vm._v(_vm._s(_vm.$moeda.formatar(aporte.ValorDoAporte)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(aporte.NomeDaCidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(aporte.NumeroDaEmenda))]), _vm._v(" "), _c('td', {
      staticClass: "u-texto-alinhado-ao-centro"
    }, [_vm._v("\n                    " + _vm._s(_vm.$tempo.formatarParaPadraoBrasileiro(aporte.DataDePublicacaoDaEmenda)))]), _vm._v(" "), _vm._l((_vm.colunasDinamicas), function(faixa) {
      return _c('td', {
        key: faixa,
        staticClass: "u-texto-alinhado-ao-centro"
      }, [_vm._v("\n                    " + _vm._s(_vm.obterPercentualDaFaixa(aporte, faixa)) + "\n                ")])
    }), _vm._v(" "), _c('td', {
      staticClass: "u-texto-alinhado-ao-centro"
    }, [_c('button', {
      class: ['botao botao_sem-preenchimento botao_medio botao_cor-terciaria', aporte.PermiteExclusaoDoAporte ? '' : 'u-desabilitado'],
      attrs: {
        "type": "button",
        "title": aporte.PermiteExclusaoDoAporte ? 'Excluir aporte' : 'Exclusão não permitida'
      },
      on: {
        "click": function($event) {
          return _vm.abrirModalDeExclusao(aporte)
        }
      }
    }, [_c('i', {
      staticClass: "fal fa-ban",
      attrs: {
        "aria-hidden": "true"
      }
    })])])], 2)
  }), _vm._v(" "), (_vm.aportesLocais.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Nenhum aporte foi encontrado")])]) : _vm._e()], 2)]), _vm._v(" "), (_vm.modalDeExclusaoEstaVisivel) ? _c('modal', {
    on: {
      "close": _vm.fecharModalDeExclusao
    }
  }, [_c('form', {
    staticClass: "formulario",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.excluirAporte.apply(null, arguments)
      }
    }
  }, [_c('h3', {
    staticClass: "titulo titulo_medio u-margem-inferior-media"
  }, [_vm._v("Confirma a exclusão do aporte?")]), _vm._v(" "), _c('hr', {
    staticClass: "u-margem-inferior-media"
  }), _vm._v(" "), _c('div', {
    staticClass: "grade__linha_alinhar-horizontal-direita formulario-button"
  }, [_c('button', {
    staticClass: "botao botao_cinza botao_medio u-margem-direita-pequena",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fecharModalDeExclusao
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "botao botao_cor-terciaria botao_medio",
    class: {
      'is-loading': _vm.loading.visivel
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Confirmar")])])])]) : _vm._e(), _vm._v(" "), _c('MensagemFlutuante', {
    attrs: {
      "mensagemVisivel": _vm.mensagemVisivel,
      "titulo": _vm.tituloMensagem,
      "estilo": _vm.estiloMensagem,
      "texto": _vm.textoMensagem
    },
    on: {
      "close": _vm.fecharMensagem
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87d70886"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/aportes/mcmv-cidades/TabelaDeAportes.vue
// module id = 1130
// module chunks = 1